import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {captureException} from '@sentry/react'
import {raise} from '@utilities/helpers.ts'
import {httpGetTreatmentRequest} from '@/features/treatment-requests/services/treatment-requests.http'
import {TreatmentRequestExtended} from '@/features/treatment-requests/types'

export const useTreatmentRequest = (
    treatmentRequestId?: string,
    options?: Omit<UseQueryOptions<TreatmentRequestExtended>, 'queryKey' | 'queryFn'>
) =>
    useQuery({
        queryKey: [QUERY_KEYS.TREATMENT_REQUESTS, treatmentRequestId],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetTreatmentRequest({
                    urlParams: {treatmentRequestId: treatmentRequestId ?? raise('treatmentRequestId is nullish')},
                    params: {responseType: 'extended'}
                }),
                onZodError: captureException,
                responseShape: TreatmentRequestExtended
            }),
        ...options
    })
